import request from '@/utils/requests'

/**
 * 生成钱包登录签名串
 * @returns 
 */
// export const generateNonce = () => {
//     return request({
//         url: '/auth/nonce',
//         method: 'post'
//     })
// }
export const generateNonce = () => {
    return request({
        url: 'https://stake-api.metaflow.club/app-api/auth/nonce',
        method: 'post'
    })
}

/**
 * 登录
 * @param {*} data 
 * @returns 
 */
// export const requestLogin = (data) => {
//     return request({
//         url: '/auth/login',
//         method: 'post',
//         headers: {
//             isToken: false,
//             isEncrypt: true,
//             repeatSubmit: false
//         },
//         data
//     })
// }
export const requestLogin = (data) => {
    return request({
        url: 'https://stake-api.metaflow.club/app-api/auth/login',
        method: 'post',
        headers: {
            isToken: false,
            isEncrypt: true,
            repeatSubmit: false
        },
        data
    })
}

/**
 * 登出
 * @returns 
 */
// export const requestLogout = () => {
//     return request({
//         url: '/auth/logout',
//         method: 'post'
//     })
// }
export const requestLogout = () => {
    return request({
        url: 'https://stake-api.metaflow.club/app-api/auth/logout',
        method: 'post'
    })
}